(function () {
	'use strict';

	/**
	* @ngdoc service
	* @name  smb-app.smbUserGroupsDataStore
	* 
	* @description 
	* A datastore used to retrieve smb-app user groups
	**/

	angular
		.module('smb-app')
		.factory('smbUserGroupsDataStore',
		[
			'pxAuthService',
			'sbUserGroupsService',
			UserGroupsDataStore
		]);

	function UserGroupsDataStore(pxAuthService, sbUserGroupsService) {
		var _userGroups = [];

		return {
			/**
			* @ngdoc method
			* @name smbUserGroupsDataStore#getUserGroups
			* @methodOf smb-app.smbUserGroupsDataStore
			* @kind function
			*
			* @description
			* Gets a collection of user groups
			*
			* @returns {Deferred} A promise that will resolve with a collection of user groups
			* 
			*/
			getUserGroups: getUserGroups,

			/**
			* @ngdoc property
			* @name smbUserGroupsDataStore#userGroups
			* @propertyOf smb-app.smbUserGroupsDataStore
			* @kind property
			*
			* @description
			* A collection of user groups
			* 
			* @returns {array} An array of user groups
			*/
			get userGroups() { return _userGroups; }
		};

		function getUserGroups() {
			return sbUserGroupsService
				.getUserGroups(pxAuthService.systemName)
				.then(function (response) {
					_userGroups = response;
					return response;
				});
		}
	}

})();


//////////////////
// WEBPACK FOOTER
// ./app/dataStores/userGroupsDataStore.js
// module id = 132
// module chunks = 1